import { InjectionToken } from '@angular/core';
import { AddressCompletionOptions } from './interfaces/address-completion-options.interface';

export const ADDRESS_COMPLETION_OPTIONS = new InjectionToken<AddressCompletionOptions>(
  'ADDRESS_COMPLETION_OPTIONS'
);
